module.exports = __webpack_public_path__ + "static/media/CC20-AP130-12.ca1e3fd5.png";